import React, { Component } from "react";
import { connect } from "react-redux";
import axios, { CancelToken } from "axios";

import { Translate, I18n } from "react-redux-i18n";

import AddGroup from "./modals/AddGroup";
import EditGroup from "./modals/EditGroup";
import ConfirmationModal from "../utils/components/ConfirmationModal";
import { searchModule } from "../utils/Utils";

import { setAlert } from "../../actions/alertActions";

import "../../styles/components/evs/GroupsTable.scss";
import pencil from "../../styles/images/pencil.svg";
import trashcan from "../../styles/images/trashcan.svg";
import no_vehicles from "../../styles/images/no_vehicles.svg";
import Spinner from "react-bootstrap/Spinner";

class GroupsTable extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      loading: true,
      groups: [],
      selectedGroup: null,
      search: "",

      modals: {
        add: false,
        edit: false,
        delete: false,
      },
    };

    this.handleAddGroup = this.handleAddGroup.bind(this);
    this.handleEditGroup = this.handleEditGroup.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchGroups(() => {
      this.safeSetState({ search: this.props.search });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.hasOwnProperty("search") &&
      this.props.hasOwnProperty("search")
    )
      if (prevProps.search !== this.props.search)
        this.safeSetState({ search: this.props.search });
  }

  componentWillUnmount() {
    this._mounted = false;
    if (this.cancel) this.cancel("Component is unmounting");
  }

  fetchGroups(callback) {
    axios
      .get("/api/private/groupDrivers")
      .then((res) => {
        this.safeSetState(
          {
            loading: false,
            groups: res.data || [],
          },
          callback
        );
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleAddGroup(e, avatar, users) {
    e.preventDefault();
    const elements = e.target.elements;
    const name = elements.name.value;

    const post = {
      name,
      imageContent: avatar,
      listOfDrivers: users.map((u) => ({
        name: u.name,
        mobile: u.mobile,
        internationalPrefix: u.internationalPrefix,
      })),
    };

    axios
      .post("/api/private/groupDrivers", post, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("groupDrivers_successAdd"), "primary");
          this.setModal("add", false);
          this.fetchGroups();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleEditGroup(e, group) {
    e.preventDefault();
    /* const elements = e.target.elements;
    const name = elements.name.value; */

    /* const patch = {
      _id: group._id,
      imageContent: group.imageContent
    }; */

    const patch = {
      _id: group._id,
      name: group.name,
      imageContent: group.imageContent,
      listOfDrivers: group.listOfDrivers.map((d) => ({
        driverId: d.driverId || "",
        active: d.active,
        name: d.name,
        mobile: d.mobile,
        internationalPrefix: d.internationalPrefix,
        new: d.new,
      })),
    };

    axios
      .patch("/api/private/groupDrivers/backOffice", patch, {
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("groupDrivers_successEdit"), "primary");
          this.setModal("edit", false);
          this.fetchGroups();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  handleDeleteGroup() {
    axios
      .delete("/api/private/groupDrivers", {
        data: { _id: this.state.selectedGroup._id },
        cancelToken: new CancelToken((c) => (this.cancel = c)),
      })
      .then((res) => {
        if (res.status === 200) {
          this.props.setAlert(I18n.t("groupDrivers_successDelete"), "primary");
          this.setModal("delete", false);
          this.fetchGroups();
        }
      })
      .catch((err) =>
        this.props.setAlert(I18n.t(err.response.data.message), "danger")
      );
  }

  setModal(modal, bool) {
    let newModals = Object.assign({}, this.state.modals);
    newModals[modal] = bool;
    this.safeSetState({
      modals: newModals,
    });
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    return (
      <>
        <button
          type="button"
          className="main-btn"
          onClick={() => this.setModal("add", true)}
          disabled={
            this.state.loading ||
            (this.props.isAdmin === false &&
              this.state.groups.length >=
                this.props.userPackage?.groupOfDriversLimit)
          }
        >
          <Translate value="drivers_addGroup" />
        </button>
        <div id="groupsTable">
          <div className="component-container">
            {this.state.loading ? (
              <div className="loading-container">
                <div className="loading-spinner">
                  <div className="generic-loading">
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
            ) : this.state.groups.length > 0 ? (
              <div className="table-container">
                <div className="table-header">
                  <div className="row no-gutters">
                    <div className="col-12 row no-gutters titles">
                      <div className="col title">
                        <Translate value="drivers_group" />
                      </div>
                      <div className="col title">
                        <Translate value="drivers_evs" />
                      </div>
                      <div className="col title">
                        <Translate value="drivers_number" />
                      </div>
                      <div className="col-2 title"></div>
                    </div>
                  </div>
                </div>
                <div className="table-values">
                  {this.state.groups
                    .filter((i) => searchModule.filter(this, i))
                    .map((g) => {
                      return (
                        <div key={g._id} className="row no-gutters">
                          <div className="col-12 row no-gutters values">
                            <div className="col">
                              {g.name ? (
                                g.name
                              ) : (
                                <Spinner
                                  className="loading-spinner"
                                  animation="grow"
                                  size="sm"
                                />
                              )}
                            </div>
                            <div className="col">
                              {g.numberOfEvs >= 0 ? (
                                g.numberOfEvs
                              ) : (
                                <Spinner
                                  className="loading-spinner"
                                  animation="grow"
                                  size="sm"
                                />
                              )}
                            </div>
                            <div className="col">
                              {g.listOfDrivers.length ? (
                                g.listOfDrivers.length
                              ) : (
                                <Spinner
                                  className="loading-spinner"
                                  animation="grow"
                                  size="sm"
                                />
                              )}
                            </div>
                            <div className="col-2">
                              <button
                                type="button"
                                className="clear"
                                onClick={() => {
                                  this.safeSetState({ selectedGroup: g }, () =>
                                    this.setModal("edit", true)
                                  );
                                }}
                              >
                                <img src={pencil} alt="" />
                              </button>
                              <button
                                type="button"
                                className="clear"
                                onClick={() => {
                                  this.safeSetState({ selectedGroup: g }, () =>
                                    this.setModal("delete", true)
                                  );
                                }}
                              >
                                <img src={trashcan} alt="" />
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            ) : (
              <div className="no-groups-container">
                <img src={no_vehicles} alt="" />
                <p className="title">
                  <Translate value="evs_noGroupsTitle" />
                </p>
                <p className="text">
                  <Translate value="evs_noGroupsText" />
                </p>
              </div>
            )}
          </div>
          <AddGroup
            show={this.state.modals.add}
            onHide={() => this.setModal("add", false)}
            onSubmit={this.handleAddGroup}
          />
          <EditGroup
            show={this.state.modals.edit}
            onHide={() => this.setModal("edit", false)}
            onSubmit={this.handleEditGroup}
            group={
              this.state.selectedGroup !== null && this.state.selectedGroup
            }
          />
          <ConfirmationModal
            show={this.state.modals.delete}
            onHide={() => this.setModal("delete", false)}
            title="drivers_deleteGroup"
            body="drivers_deleteGroupText"
            button="drivers_deleteGroup"
            onConfirm={this.handleDeleteGroup}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userPackage: state.account.accountData.userPackage,
  isAdmin: state.account.isAdmin,
});

export default connect(mapStateToProps, { setAlert })(GroupsTable);
